import dayjs from 'dayjs'

export function formatDate(dateString: string): string {
  return dayjs(dateString).format('MM/DD/YYYY HH:mm')
}

export function getStatusColor(status: number): string {
  if (status >= 200 && status < 300) {
    return 'success'
  }
  if (status >= 400 && status < 500) {
    return 'warning'
  }
  if (status >= 500) {
    return 'error'
  }
  return 'default'
}

export function getStatusText(status: number): string {
  const statusMap: Record<number, string> = {
    200: 'OK',
    204: 'No Content',
    400: 'Bad Request',
    401: 'Unauthorized',
    403: 'Forbidden',
    404: 'Not Found',
    500: 'Internal Server Error',
    502: 'Bad Gateway',
    503: 'Service Unavailable'
  }

  return statusMap[status] || status.toString()
}

export function formatEntity(entity: string | null): string {
  if (!entity) {
    return '-'
  }

  const entityMap: Record<string, string> = {
    '001': 'TN',
    '003': 'WI'
  }

  return entityMap[entity] || entity
}

export function truncateUrl(url: string, maxLength: number = 50): string {
  if (url.length <= maxLength) {
    return url
  }
  return `${url.substring(0, maxLength)}...`
}

export function formatHeaders(headers: Record<string, string>): string {
  const importantHeaders = ['user-agent', 'content-type', 'authorization']
  const filtered = Object.entries(headers)
    .filter(([key]) => importantHeaders.includes(key.toLowerCase()))
    .map(([key, value]) => `${key}: ${value}`)
    .join('\n')

  return filtered || 'No important headers'
}

export function formatQueryParams(params: Record<string, string>): string {
  return (
    Object.entries(params)
      .map(([key, value]) => `${key}=${value}`)
      .join('&') || 'No parameters'
  )
}

export function getEntityOptions() {
  return [
    { label: 'TN (001)', value: '001' },
    { label: 'WI (003)', value: '003' }
  ]
}

export function getStatusOptions() {
  return [
    { label: '200 OK', value: '200' },
    { label: '204 No Content', value: '204' },
    { label: '400 Bad Request', value: '400' },
    { label: '401 Unauthorized', value: '401' },
    { label: '404 Not Found', value: '404' },
    { label: '500 Internal Server Error', value: '500' }
  ]
}

export function getTokenValidOptions() {
  return [
    { label: 'Valid', value: 'true' },
    { label: 'Invalid', value: 'false' }
  ]
}

export function getOperationOptions() {
  return [
    { label: 'Hold', value: 'true' },
    { label: 'Unhold', value: 'false' }
  ]
}
